import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';

const ShellLockContext = createContext(null);

export const ShellLockProvider = ({ children, onLockChange }) => {
  const [lockCount, setLockCount] = useState(0);
  const onLockChangeRef = useRef(onLockChange);

  useEffect(() => {
    onLockChangeRef.current = onLockChange;
  }, [onLockChange]);

  const lock = useCallback(() => {
    setLockCount((prev) => {
      const next = prev + 1;
      if (prev === 0) onLockChangeRef.current?.(true);
      return next;
    });
  }, []);

  const unlock = useCallback(() => {
    setLockCount((prev) => {
      const next = Math.max(0, prev - 1);
      if (next === 0 && prev > 0) onLockChangeRef.current?.(false);
      return next;
    });
  }, []);

  const isLocked = lockCount > 0;

  return (
    <ShellLockContext.Provider value={{ isLocked, lock, unlock }}>
      {children}
    </ShellLockContext.Provider>
  );
};

export const useShellLock = () => {
  const context = useContext(ShellLockContext);
  if (!context) {
    throw new Error('useShellLock must be used within ShellLockProvider');
  }
  return context;
};
